import { render, staticRenderFns } from "./TagCombo.vue?vue&type=template&id=dc81756a&scoped=true"
import script from "./TagCombo.vue?vue&type=script&lang=js"
export * from "./TagCombo.vue?vue&type=script&lang=js"
import style0 from "./TagCombo.vue?vue&type=style&index=0&id=dc81756a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc81756a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
